import AscModal from "../AscModal/AscModal";
import AscButton from "../AscButton/AscButton";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscPaymentMethods from "../AscPaymentMethods/AscPaymentMethods";

import { CloseIcon } from "../AscIcons";
import { AscModalPurchaseCreditsPropsI } from "./AscModalPurchaseCredits.type";
import styles from "./AscModalPurchaseCredits.module.scss";
import { ChangeEvent, useCallback, useState } from 'react';
import AscTextInput from "../AscInputFields/AscTextInput/AscTextInput";
import AscDropdown from "../AscDropdown/AscDropdown";
import { capitalize } from "lodash";
import { useAscContext } from '../../context';

function AscModalPurchaseCredits({
  visible,
  setVisible,
  title,
  paymentMethods,
  handleBuyCredits,
  disableBuyAction,
}: AscModalPurchaseCreditsPropsI) {
  const [inputVal, setInputVal] = useState("500");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [dropdownTitle, setDropdownTitle] = useState("Payment method");
  const {toast} = useAscContext()
  function closeModal() {
    setVisible(false);
  }
  const handlePurchase = () => {
    if (!selectedPaymentMethod){
      toast('You need to select payment method', {type:'warning'})
      return
    }
    //try parsing inputVal to number
    const parsedInputVal = parseInt(inputVal);
    if (isNaN(parsedInputVal)) {
      toast.warning("Please enter a valid number");
      return;
    }
    handleBuyCredits(parsedInputVal, paymentMethods[0].id);
  };
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputVal(e.currentTarget.value);
  };

  const handlePaymentMethodClick = (id: string, title: string) => {
    setSelectedPaymentMethod(id);
    setDropdownTitle(title);
  };
  const handleCancel = useCallback(()=>{
      setVisible(false)
  },[setVisible])
  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      withBackground={false}
    >
      <div className={styles.element}>
        <CloseIcon
          className={styles.closeIcon}
          onClick={closeModal}
          data-testid={"test-close-icon"}
        />
        <AscHeading className={styles.title} level={6}>
          {title}
        </AscHeading>

        <span className={styles.text}>Amount of credits</span>
        <AscTextInput
          className={styles.selectInput}
          onChange={handleInputChange}
          value={inputVal}
        />
        {paymentMethods.length > 0 && (
          <AscDropdown
            title={dropdownTitle}
            className={styles.payment_dropdown}
            titleContainerClassName={styles.titleContainerClassName}
            optionContainerClassName={styles.optionContainerClassName}
            optionItemClassName={styles.optionItemClassName}
          >
            {paymentMethods.map((el) => (
              <AscDropdown.Option
                key={el.id}
                onClick={() =>
                  handlePaymentMethodClick(
                    el.id,
                    `${capitalize(el.brand)} - ${el.last4}`
                  )
                }
              >
                <AscPaymentMethods
                  key={el.id}
                  data={el}
                  className={styles.payment}
                  size="small"
                />
              </AscDropdown.Option>
            ))}
          </AscDropdown>
        )}
        <div className={styles.buttonGround}>
          <AscButton className={styles.button} variant="secondary" onClick={handleCancel}>
            Cancel
          </AscButton>
          <AscButton disabled={disableBuyAction} loading={disableBuyAction} onClick={handlePurchase} className={styles.button}>
            Purchase
          </AscButton>
        </div>
      </div>
    </AscModal>
  );
}

export default AscModalPurchaseCredits;
